import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { toggleAutoPlay } from 'shared/redux/auto-play'
import * as selectors from 'shared/redux/reducers'
import Grid from 'shared/components/search/grid'
import { AutoPlayHeader } from '../components/header/header'

@connect(
    state => ({
        autoPlay: selectors.getAutoPlay(state),
    }),
    { toggleAutoPlay },
)
export default class Favorites extends PureComponent {
    render() {
        const { autoPlay, toggleAutoPlay } = this.props
        return (
            <div>
                <div>
                    <AutoPlayHeader onToggleAutoPlay={toggleAutoPlay} autoPlay={autoPlay} />
                    <div style={{ clear: 'both' }} />
                </div>
                <Grid />
            </div>
        )
    }
}
